import React, {useState, useEffect} from "react";
import BackButton from "components/Button/BackButton";
import SaveButton from "components/Button/SaveButton";
import DeleteButton from "components/Button/DeleteButton";
import useFetch from "utils/hooks/useFetch";
import { useNavigate } from "react-router-dom";
import { ApiResponseStatusUnauthorized, ApiResponseSuccess, EmptyString, FormTypeAdd, FormTypeEdit } from "utils/Constant";
import FailModal from "components/modal/FailModal";
import LoadingModal from "components/modal/LoadingModal";
import SuccessModal from "components/modal/SuccessModal";
import ConfirmationModal from "components/modal/ConfirmationModal";
import { ApiCheckIsAdmin, ApiCheckUsername, ApiCreateUserLocation, ApiDeleteUser, ApiDeleteUserLocation, ApiGetAvailableLocationList, ApiGetUserById, ApiGetUserLocationByUserId, ApiRegister, ApiUpdateUser } from "utils/constants/api";
import Dropdown from "components/Input/Dropdown";
import { GetStatus } from "utils/helpers";
import moment from "moment";
import UnDeleteButton from "components/Button/UnDeleteButton";
import TrashIcon from "assets/icon/TrashIcon";

export default function UserForm(){
    let navigate = useNavigate()

    const { fetch: registerUser } = useFetch(ApiRegister)
    const { fetch: updateUser } = useFetch(ApiUpdateUser)
    const { fetch: getUserById } = useFetch(ApiGetUserById)
    const { fetch: deleteUser } = useFetch(ApiDeleteUser)
    const { fetch: checkIsAdmin } = useFetch(ApiCheckIsAdmin)
    const { fetch: apiGetAvailableLocation } = useFetch(ApiGetAvailableLocationList)
    const { data: userLocationList ,fetch: apiGetUserLocationList } = useFetch(ApiGetUserLocationByUserId)
    const { fetch: apiCreateUserLocation } = useFetch(ApiCreateUserLocation)
    const { fetch: apiDeleteUserLocation } = useFetch(ApiDeleteUserLocation)
    const { fetch: apiCheckUsername } = useFetch(ApiCheckUsername)

    let queryString = new URLSearchParams(window.location.search)
    let formType = queryString.get("formType")
    let paramUserId = queryString.get("userId")
    
    const [userId, setUserId] = useState(EmptyString)
    const [username, setUsername] = useState(EmptyString)
    const [name, setName] = useState(EmptyString)
    const [email, setEmail] = useState(EmptyString)    
    const [password, setPassword] = useState(EmptyString)
    const [confirmPassword, setConfirmPassword] = useState(EmptyString)
    const [isAdmin, setIsAdmin] = useState(false)
    const [status, setStatus] = useState(EmptyString)
    const [createDate, setCreateDate] = useState(EmptyString)
    const [updateDate, setUpdateDate] = useState(EmptyString)
    const [updateBy, setUpdateBy] = useState(EmptyString)

    const [locationOptions, setLocationOptions] = useState([])
    const [locationId, setLocationId] = useState('')
    const [isSaveButtonDisabled, setIsSaveButtonDisabled] = useState(false)
    const [locationList, setLocationList] = useState([])

    const [errorUsername, setErrorUsername] = useState(false)
    const [errorUsernameMessage, setErrorUsernameMessage] = useState("Username is required!")
    const [errorName, setErrorName] = useState(false)
    const [errorPassword, setErrorPassword] = useState(false)
    const [errorConfirmPassword, setErrorConfirmPassword] = useState(false)
    const [errorConfirmPasswordMessage, setErrorConfirmPasswordMessage] = useState(EmptyString)
    
    const [failModal, setFailModal] = useState({ isOpen: false, data: {}, message: EmptyString })
	const [loading, setLoading] = useState({isOpen: false})
    const [successModal, setSuccessModal] = useState({ isOpen: false, data: {} })
    const [confirmationModal, setConfirmationModal] = useState({ isOpen: false, data: {} })
    
    // Button Event
    const saveBtnClick = () => {
        if(fFormValidation()){
            setConfirmationModal({ isOpen: true, data: { onSuccess: async () => { 
                setConfirmationModal({ isOpen: false })
                setLoading({isOpen: true})

                if(formType === FormTypeAdd){
                    fInsertUser().then(() => {
                        setLoading({isOpen: false})
                    })
                }else{
                    fUpdateUser().then(() => {
                        setLoading({isOpen: false})
                    })
                }
            }}})
        }
    }
    const deleteBtnClick = () => {
        setConfirmationModal({ isOpen: true, data: { onSuccess: async () => { 
            setConfirmationModal({ isOpen: false })
            setLoading({isOpen: true})
            
            let stat

            if (status === 1){
                stat = "2"
            }else{
                stat = "1"
            }

            fDeleteUser(paramUserId, stat).then(() => {
                setLoading({isOpen: false})
            })
        }}})
    }
    const backBtnClick = () => {
        navigate(-1)
    }
    const giveLocationAccessBtnClick = () => {
        // Validasi
        if (locationId === null || locationId === ''){
            errorModal('Lokasi harus dipilih!')
            return
        }

        if (paramUserId === null || paramUserId === ''){
            errorModal('Tidak ada user id!')
            return
        }

        setLoading({ isOpen: true })

        insertUserLocation().then(() => {
            getLocationList().then(() => {
                getUserLocationList().then(() => {
                    setLoading({ isOpen: false })
                })
            })
        })
    }
    const deleteLocationAccessBtnClick = (id) => {
        setConfirmationModal({ isOpen: true, data: { onSuccess: async () => { 
            setConfirmationModal({ isOpen: false })
            setLoading({ isOpen: true })

            deleteUserLocation(id).then(() => {
                getLocationList().then(() => {
                    getUserLocationList().then(() => {
                        setLoading({ isOpen: false })
                    })
                })                
            })
        }}})
    }
    
    // Function Api Call
    async function fInsertUser(){
        await registerUser({
            data: {
                username: username,
                fullName: name,
                password: password,
                isAdmin: isAdmin,
                companyId: localStorage.getItem("CompanyId")
            }
        }).then((response) => {
            if (checkResponse(response)) {
                setSuccessModal({ 
                    isOpen: true, 
                    data: { 
                        onSuccess: async () => { 
                            navigate("/user") 
                        }
                    } 
                })
            }
        })
    }
    async function fUpdateUser(){
        await updateUser({
            data: {
                userId: paramUserId,
                username: username,
                fullName: name,
                password: password,
                isAdmin: isAdmin,
                companyId: localStorage.getItem("CompanyId")
            }
        }).then((response) => {
            if (checkResponse(response)) {
                setSuccessModal({ 
                    isOpen: true, 
                    data: { 
                        onSuccess: async () => { 
                            navigate("/user") 
                        }
                    } 
                })
            }
        })
    }
    async function fDeleteUser(id, status){
        await deleteUser({
            data: {
                userId: id,
                status: status
            }
        }).then((response) => {
            if (checkResponse(response)) {
                setSuccessModal({ 
                    isOpen: true, 
                    data: {
                        onSuccess: async () => {
                            setSuccessModal({ isOpen: false })
                            navigate("/user")
                        }
                    }
                })
            }
        })
    }
    async function fGetUserById(paramUserId){
        await getUserById({
            data: {
                userId: paramUserId
            }
        }).then((response) => {
            if (checkResponse(response)) {
                let data = response.data

                setUserId(data.userId)
                setUsername(data.username)
                setName(data.fullName)
                setIsAdmin(data.isAdmin)
                setStatus(data.status)
                setCreateDate(data.createdDate)
                setUpdateDate(data.updatedDate)
                setUpdateBy(data.updatedBy)
            }
        })
    }
    async function fCheckIsAdmin(){
        await checkIsAdmin({
            data: {
                userId: localStorage.getItem("Id")
            }
        }).then((response) => {
            if (checkResponse(response)){
                if (response.data.isAdmin === false){
                    setFailModal({
                        isOpen: true,
                        data: {
                            onSuccess: async () => {
                                setFailModal({isOpen: false})
                                localStorage.setItem("IsAdmin", "0")
                                window.location.href = "/"
                            }
                        },
                        message: "User don't have admin access right!"
                    })
                }
            }
        })
    }
    const getLocationList = async() => {
        await apiGetAvailableLocation({
            data: {
                userId: paramUserId
            }
        }).then((res) => {
            if (checkResponse(res)) {
                let tempArray = []
                tempArray.push({label: "Select Location", value: ""})

                for (let i = 0; i < res.data.length; i++){
                    tempArray.push({ label: res.data[i].locationName, value: String(res.data[i].locationId) })
                }

                setLocationOptions(tempArray)
                setLocationId(tempArray[0].value)
            }
        })
    }
    const getUserLocationList = async() => {
        await apiGetUserLocationList({
            data: {
                userId: paramUserId
            }
        }).then((res) => {
            checkResponse(res)
        })
    }
    const insertUserLocation = async() => {
        await apiCreateUserLocation({
            data: {
                userId: paramUserId, 
                locationId: locationId
            }
        }).then((response) => {
            checkResponse(response)
        })
    }
    const deleteUserLocation = async(id) => {
        await apiDeleteUserLocation({
            data: {
                userLocationId: id
            }
        }).then((response) => {
            checkResponse(response)
        })
    }
    const checkUsername = async() => {
        await apiCheckUsername({
            data: {
                username
            }
        }).then((response) => {
            if (checkResponse(response)) {
                console.log(response)
                if (response.data.duplicate) {
                    setErrorUsernameMessage("Username already taken!")
                    setErrorUsername(true)
                    setIsSaveButtonDisabled(true)
                } else {
                    setErrorUsernameMessage("Username is required!")
                    setErrorUsername(false)
                    setIsSaveButtonDisabled(false)
                }
            }
            
        })
    }

    // Function
    function fFormValidation(){
        let errorCount = 0

        if (username === EmptyString || username === null){
            setErrorUsername(true)
            errorCount++
        }else{
            setErrorUsername(false)
        }

        if (name === EmptyString || name === null){
            setErrorName(true)
            errorCount++
        }else{
            setErrorName(false)
        }

        if (password === EmptyString || password === null){
            setErrorPassword(true)
            errorCount++
        }else{
            setErrorPassword(false)
        }

        if (confirmPassword === EmptyString || confirmPassword === null){
            setErrorConfirmPasswordMessage("Confirm Password is required")
            setErrorConfirmPassword(true)
            errorCount++
        }else{
            setErrorConfirmPassword(false)
        }

        if(errorCount > 0){
            return false
        }else{
            return true
        }
    }
    function fHandleConfirmPasswordInput(value){
        if (password !== value){
            setErrorConfirmPasswordMessage("Password did not match!")
            setErrorConfirmPassword(true)
        }else{
            setErrorConfirmPassword(false)
        }
    }

    const checkResponse = (res) => {
        if(res.status === ApiResponseSuccess){
            return true
        }else if(res.status === ApiResponseStatusUnauthorized){
            setFailModal({
                isOpen: true,
                data: {
                    onSuccess: async () => {
                        setFailModal({isOpen: false})
                        window.location.href = "/login"
                    }
                },
                message: res.message
            })
            return false
        }else{
            setFailModal({
                isOpen: true,
                data: {
                    onSuccess: async () => {
                        setFailModal({isOpen: false})
                    }
                },
                message: res.message
            })
            return false
        }
    }
    const errorModal = (message) => {
        setFailModal({
            isOpen: true,
            data: {
                onSuccess: async () => {
                    setFailModal({isOpen: false})
                }
            },
            message: message
        })
    }
    
    useEffect(() => {
        if (formType === FormTypeAdd){
            checkUsername()
        }       
    }, [username])
    useEffect(() => {
        setLoading({isOpen: true})
        fCheckIsAdmin().then(() => {
            if (formType === FormTypeEdit){
                setLoading({isOpen: true})

                fGetUserById(paramUserId).then(() => {
                    getLocationList().then(() => {
                        getUserLocationList().then(() => {
                            setLoading({isOpen: false})
                        })
                    })
                })
            }else{
                setLoading({isOpen: false})
            }
        })
    }, [])

    return(
        <div className="flex flex-col gap-2">
            <div className="flex justify-between">
                <span className="font-semibold text-2xl">User Detail</span>
                <div className={`flex gap-2 items-end justify-end ${ formType === FormTypeAdd ? 'hidden' : 'block'}`}>
                    <span className="text-sm opacity-60">
                        Status : {GetStatus(status)} | Created Date : {moment(createDate).format("DD MMM yyyy")} | Last Updated : {moment(updateDate).format("DD MMM yyyy")} | Updated By : {updateBy}
                    </span>
                </div>
            </div>
            <hr />

            <div className="mt-5 flex flex-col gap-3">
                {/* Username */}
                <div>
                    <div className="flex flex-col sm:flex-row sm:items-center">
                        <div className="w-48">
                            <span>Username</span>
                        </div>
                        <div className="px-4 hidden sm:block">
                            <span>:</span>
                        </div>
                        <div className="w-full sm:w-72">
                            <input className="input" value={ username } onChange={(e) => { setUsername(e.target.value) }} maxLength={20} disabled={formType === FormTypeEdit ? true : false} />
                        </div>
                    </div>
                    <div className={`flex items-center ${errorUsername ? 'block' : 'hidden'}`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">{errorUsernameMessage}</span>
                    </div>
                </div>

                {/* Name */}
                <div>
                    <div className="flex flex-col sm:flex-row sm:items-center">
                        <div className="w-48">
                            <span>Name</span>
                        </div>
                        <div className="px-4 hidden sm:block">
                            <span>:</span>
                        </div>
                        <div className="w-full sm:w-72">
                            <input className="input" value={name} onChange={(e) => { setName(e.target.value) }} maxLength={30} />
                        </div>
                    </div>
                    <div className={`flex items-center ${ errorName ? 'block' : 'hidden' }`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Name is required!</span>
                    </div>
                </div>

                {/* Password */}
                <div>
                    <div className="flex flex-col sm:flex-row sm:items-center">
                        <div className="w-48">
                            <span>Password</span>
                        </div>
                        <div className="px-4 hidden sm:block">
                            <span>:</span>
                        </div>
                        <div className="w-full sm:w-72">
                            <input type="password" className="input" value={password} onChange={(e) => { setPassword(e.target.value) }} />
                        </div>
                    </div>
                    <div className={`flex items-center ${ errorPassword ? 'block' : 'hidden' }`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Password is required!</span>
                    </div>
                </div>

                {/* Confirm Password */}
                <div>
                    <div className="flex flex-col sm:flex-row sm:items-center">
                        <div className="w-48">
                            <span>Confirm Password</span>
                        </div>
                        <div className="px-4 hidden sm:block">
                            <span>:</span>
                        </div>
                        <div className="w-full sm:w-72">
                            <input type="password" className="input" value={confirmPassword} onChange={(e) => {setConfirmPassword(e.target.value)}} onInput={(e) => { fHandleConfirmPasswordInput(e.target.value) }} />
                        </div>
                    </div>
                    <div className={`flex items-center ${ errorConfirmPassword ? 'block' : 'hidden' }`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">{ errorConfirmPasswordMessage }</span>
                    </div>
                </div>

                {/* Admin */}
                <div>
                    <div className="flex items-center">
                        <div className="w-48">
                            <span>Admin</span>
                        </div>
                        <div className="px-4 hidden sm:block">
                            <span>:</span>
                        </div>
                        <div className="w-full sm:w-72 flex items-center">
                            <input type="checkbox" className="" value={isAdmin} onChange={(e) => {setIsAdmin(!isAdmin)}} checked={isAdmin} />
                        </div>
                    </div>
                </div>

                {/* Button */}
                <div className="mt-5 flex flex-wrap justify-end gap-2">
                    <SaveButton onClick={saveBtnClick} visible={true} disabled={isSaveButtonDisabled} />
                    <DeleteButton onClick={deleteBtnClick} visible={formType === FormTypeEdit ? (status === 1 ? true : false) : false} />
                    <UnDeleteButton onClick={deleteBtnClick} visible={formType === FormTypeEdit ? (status === 2 ? true : false) : false} />
                    <BackButton onClick={backBtnClick} />
                </div>
            </div>

            { formType === FormTypeEdit && (
                <div className="mt-5">
                    <div>
                        <span className="text-xl font-semibold">Location Access</span>
                    </div>

                    <div className="flex items-center mt-4">
                        <span>Lokasi</span>
                        <div className="w-72 ml-12">
                            <Dropdown options={locationOptions} value={locationId} onChange={(e) => { setLocationId(e.value) }} placeholder={'Pilih Lokasi'} />
                        </div>
                        <button className="button ml-2" onClick={giveLocationAccessBtnClick}>
                            <span>Beri Akses</span>
                        </button>
                    </div>

                    <div className="mt-5 overflow-hidden sm:rounded-3xl border shadow-sm">
                        <table className="w-full bg-white hidden sm:table">
                            <thead>
                                <tr className="h-12">
                                    <th className="font-semibold w-16">No</th>
                                    <th className="font-semibold text-left px-2">Lokasi</th>
                                    <th className="font-semibold text-center px-2">Action</th>
                                </tr>
                            </thead>
                            <tbody className="">
                                { userLocationList?.data?.length < 1 && (
                                    <tr className="border-t">
                                        <td colSpan={9} className="text-center py-3">
                                            <span>No Data Available</span>
                                        </td>
                                    </tr>
                                )}
                                { userLocationList?.data?.map((data, i) => {
                                    return(
                                        <tr 
                                            className="my-2 row border-t" 
                                            key={ i }
                                        >
                                            <td className="text-center">{ i + 1 }</td>
                                            <td className="px-2">
                                                <span>{ data.locationName }</span>
                                            </td>
                                            <td className="px-2 hidden sm:table-cell py-2 text-center">
                                                <button className="bg-black px-3 py-2 rounded-md hover:bg-slate-600" onClick={() => {deleteLocationAccessBtnClick(data.userLocationId)}}>
                                                    <TrashIcon className="fill-white w-4 h-4" />
                                                </button>
                                            </td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}
            
            
            {/* Modal */}
			{failModal.isOpen && ( <FailModal onClose={() => setFailModal({ isOpen: false, data: {}, message: EmptyString })} data={failModal?.data} message={failModal?.message} /> )}
			{loading.isOpen && (<LoadingModal onClose={() => setLoading({ isOpen: false })} />)}
            {successModal.isOpen && ( <SuccessModal onClose={() => setSuccessModal({ isOpen: false, data: {} })} data={successModal?.data} /> )}
            {confirmationModal.isOpen && ( <ConfirmationModal onClose={() => setConfirmationModal({ isOpen: false, data: {} })} data={confirmationModal?.data} /> )}
        </div>
    )
}